import {PagedNotificationsList} from '../models/Notifications';

export const UPDATE_NOTIFICATIONS_LIST = 'UPDATE_NOTIFICATIONS_LIST';

export interface UpdateNotificationsListAction {
  type: typeof UPDATE_NOTIFICATIONS_LIST;
  payload: PagedNotificationsList;
}

export type NotificationsActionTypes = UpdateNotificationsListAction;